import { Buffer } from 'buffer';
import makeHeaders from "./headers";

const { REACT_APP_BASE_API_URI } = process.env;

export const searchData = async (dataType, searchCriteria) => {
  const headers = await makeHeaders();
  try {
    const response = await fetch(`${REACT_APP_BASE_API_URI}/search/${dataType}`, {
      headers,
      method: 'POST',
      body: JSON.stringify(searchCriteria)
    });
    if (!response.ok) throw new Error(response.json());
    return await response.json();
  } catch(error) {
    throw error;
  }
}

export const getPDF = async (documentId, documentType, source) => {
  const headers = await makeHeaders();
  const fetchURL = `${REACT_APP_BASE_API_URI}/document/${documentType}/${documentId}/${source}`;
  const response = await fetch(
    fetchURL,
    { headers }
  );

  if (!response.ok) {
    const json = await response.json();
    throw new Error(json.error);
  }

  const { data } = await response.json();
  console.log({data})
  const base64String = Buffer.from(data).toString('base64');
  return base64String;
}

export const getSFMCContent = async (documentId, documentType, source, documentDate) => {
  const headers = await makeHeaders();
  const fetchURL = `${REACT_APP_BASE_API_URI}/document/${documentType}/${documentId}/${source}?documentDate=${documentDate}`;
  const response = await fetch(
    fetchURL,
    { headers }
  );

  if (!response.ok) {
    const json = await response.json();
    throw new Error(json.error);
  }

  const body = await response.json();
  const htmlString = body.HTMLContent;
  
  return htmlString;
}


export const getWorkOrderDocuments = async (documentId) => {
  const headers = await makeHeaders();
  const response = await fetch(
    `${REACT_APP_BASE_API_URI}/document/work-order/${documentId}`,
    { headers }
  );

  if (!response.ok) {
    const json = await response.json();
    throw new Error(json.error);
  }

  return await response.json();
}

export const getSearchLimit = async () => {
  const headers = await makeHeaders();
  try {
    const response = await fetch(`${REACT_APP_BASE_API_URI}/search/limit`, {
      headers,
      method: 'GET'
    });
    if (!response.ok) throw new Error(response.json());
    return await response.json();
  } catch(error) {
    console.error(error);
    return [];
  }
}

export const getFeatureFlags = async () => {
  const headers = await makeHeaders();
  try {
    const response = await fetch(`${REACT_APP_BASE_API_URI}/feature-flags`, {
      headers,
      method: 'GET'
    });
    
    if (!response.ok) {
        const errorData = await response.json();
        throw new Error(JSON.stringify(errorData));
    }
    
    return await response.json();
  } catch(error) {
    console.error('API Error fetching feature flags:', error);
    return { features: { enableConvertWorkOrder: false } };
  }
}

export const getProductSkus = async (productSku) => {
  const headers = await makeHeaders();
  try {
    const response = await fetch(`${REACT_APP_BASE_API_URI}/productskus/${productSku}`, {
      headers,
      method: 'GET'
    });
    if (!response.ok) throw new Error(response.json());
    return await response.json();
  } catch(error) {
    throw error;
  }
}

export const getCustomerCrossReferenceRecord = async (odsCustomerId) => {
  const headers = await makeHeaders();
  try {
    const response = await fetch(`${REACT_APP_BASE_API_URI}/customer-cross-reference-record/${odsCustomerId}`, {
      headers,
      method: 'GET'
    });
    if (!response.ok) throw new Error(response.json());
    return await response.json();
  } catch(error) {
    throw error;
  }
}

export const sendQuoteForConversion = async (quote, optionChosen) => {
  const headers = await makeHeaders();

  const quoteObject = {
    optionSelected: [optionChosen],
    quote: quote
  }

  try {
    const response = await fetch(`${REACT_APP_BASE_API_URI}/convert/quote`, {
      headers,
      method: 'POST',
      body: JSON.stringify(quoteObject)
    });
    if (!response.ok) {
      const err = await response.json();
      throw new Error(JSON.stringify(err));
    }
    // response success will only return a "201 Created" status with no body
    return response.status;
  } catch(error) {
    console.log(error);
    throw await error;
  }
}


export const searchProductCodes = async (query, limit = 50) => {
  const headers = await makeHeaders();
  const response = await fetch(
    `${REACT_APP_BASE_API_URI}/product-search`,
    {
      headers,
      method: 'POST',
      body: JSON.stringify({ query, limit })
    }
  );
  if (!response.ok) {
    const json = await response.json();
    throw new Error(json.error || 'Product search failed');
  }
  return await response.json();
}
